import { toast } from 'react-toastify';
import React, { useState } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import { BeatLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { Button, InputAdornment, TextField } from '@material-ui/core';

import Prompt from '../../Shared/Prompt/Prompt';
import PromptWrapper from '../../Shared/Prompt/Wrapper';
import PromptActions from '../../Shared/Prompt/Actions';

import { decodeHTMLEntities } from '../../../Functions/utils';
import { changeUsername } from '../../../Functions/user';
import { useAppContext } from '../../../Context/App/Provider';

import { toastTimerValue } from '../../../Shared/utils';

import '../../SweetAlert.css'

export default function ChangeUsername({ setChangeUsername }) {
  const { t } = useTranslation();
  const [{ user, forceReload }, appDispatch] = useAppContext();

  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState(user.email);


  const handleChangeUsername = async (e, username) => {
    e.preventDefault();

    // ***** if (window.confirm(t('settings.username.confirm'))) {
    //   Swal({
    //   title: t('global.dialog_title'),
    //   text: t('settings.username.confirm'),
    //   // icon: "warning",
    //   buttons: {
    //     confirm: {
    //       text: t("global.yes"),
    //       value: true,
    //       visible: true,
    //       className: "btnPrimary",
    //       closeModal: true
    //     },
    //     cancel: {
    //       text: t("global.no"),
    //       value: false,
    //       visible: true,
    //       className: "btnSecondary",
    //       closeModal: true,
    //     }
    //   },
    //   closeOnClickOutside: false
    // }).then(async (value) => {
    //   if (value) {
    //     setLoading(true);

    //     const res = await changeUsername(username);
    //     setLoading(false);

    //     if (!res.success)
    //       return toast(t('settings.errors.username.' + res), { type: 'error' });

    //     appDispatch({ forceReload: true });

    //     toast(t('settings.username.success'), { type: 'success' });
    //     setChangeUsername(false);
    //   }
    // });

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('settings.username.confirm'),
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then(async (value) => {
      // console.log("83 - value=", value);

      if (value && value.isConfirmed) {
      setLoading(true);
      const res = await changeUsername(username);
      setLoading(false);

        if (!res.success) {
          return toast(decodeHTMLEntities(t('settings.errors.username.' + res)), { type: 'error' });

          // return Swal.fire({
          //   toast: true,
          //   icon: 'error',
          //   title: t('settings.errors.username.' + res),
          //   animation: true,
          //   position: 'top-right',
          //   showConfirmButton: false,
          //   timer: toastTimerValue,
          //   timerProgressBar: true,
          //   iconColor: 'white',
          //   customClass: {
          //     popup: 'colored-toast',
          //   },
          //   didOpen: (toast) => {
          //     toast.addEventListener('mouseenter', Swal.stopTimer)
          //     toast.addEventListener('mouseleave', Swal.resumeTimer)
          //     toast.addEventListener('click', Swal.close)
          //   }
          // });
        }

      appDispatch({ forceReload: true });

        toast(decodeHTMLEntities(t('settings.username.success')), { type: 'success' });
        // Swal.fire({
        //   toast: true,
        //   icon: 'success',
        //   title: t('settings.username.success'),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      setChangeUsername(false);
    }
    });
  };


  // console.log("43 - user=", user);

  return (
    <Prompt animated>
      <form className="prompt__container animated" style={{ height: '60%' }} onSubmit={e => handleChangeUsername(e, username)}>
        <PromptWrapper className="prompt__wrapper">
          <div className="prompt__title">
            <h1>{t('settings.username.change')}</h1>
          </div>

          <div className="prompt__content">
            {/* <TextField variant="outlined" style={{ display: 'none' }} name="username" value={user.email} /> */}

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">account_circle</span>
                </InputAdornment>
              }}
              variant="outlined"
              autoComplete="off"
              value={username}
              label={t('settings.username.label')}
              onChange={e => setUsername(e.target.value)}
            />
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setChangeUsername(false)}>
            {t('global.cancel')}
          </Button>

          <Button
            className="btnPrimary" type="submit"
            disabled={username === user.email || loading}
          >
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.confirm')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
